module Meevo.Components.ImageFileUpload {
    "use strict";
    import FileTypes = Meevo.Model.FileTypes;
    import FileMetadata = Meevo.Model.FileMetadata;
    import StorageTypeEnum = Meevo.Model.StorageTypeEnum;

   export class MeevoImageFileUpload implements angular.IDirective {
        restrict = "E";

        scope = {
            disabled: "=ngDisabled",
            required: "=ngRequired",
            fileType: "=",
            meevoFile: "=",
            fileGuid: "=",
            isStorageUpdated: "=?",
            mimeType: "=?",
            savefile: "=",
            upload: "=?"
        };

        templateUrl = "app/components/ImageFileUpload/imageFileUploadTemplate.html";

        link = (scope: any, elem: JQuery, attrs: angular.IAttributes) => {


            let fetching = false;
            let uploading = false;
            let fileUploadError = null;
            let config = null;
            let showCropShape = false;

           
            scope.config = null;
            scope.fileUploadError = null
            scope.croppedData = null

            scope.fetchConfig = () => {
                scope.fetching = true;
                scope.unable = 'false';

                scope.file = scope.displayData = scope.croppedData = scope.meevoFileImageUrl = scope.fileGuid = null;
                let uri = `/${Meevo.AppSettings.Default.API_ROOT}/storage/configuration/${scope.fileType}`;
                let parameters = {
                    mimeType: scope.mimeType
                };

                this.dataService.customMethodData(uri, 'GET', '', parameters)
                    .then(res => {
                        //scope.config = res.config;
                        scope.meevoFile = res.data;
                        scope.config = scope.meevoFile.config;
                        /*isStorageupdated set to true, in fetch config, will be only set for upload new image*/
                        scope.isStorageUpdated = true;
                        //scope.getNgfValidateConfig();
                        let fileMd: FileMetadata;
                        if (fileMd === undefined) {
                            fileMd = scope.config.filesMetadata[0];
                        }
                        if (fileMd.maxSizeMb) {
                            scope.config.maxSize = `${String(fileMd.maxSizeMb)}MB`
                        }
                    })
                    .finally(() => {
                        scope.showCropShape = Model.Guard.isSomething(scope.meevoFile.config) && Model.Guard.isSomething(scope.meevoFile.config.cropShape);
                        scope.fetching = false;
                    });
            }


            scope.uploadFile = () => {
                var deferred = this.$q.defer();



                /*if the istorageupdated is false, means it is edit comment scenario , no image update skip , and resolve the promise
                   if  if (fileData.file != null) the getfile has no file selected, then dont go to the upload to S3bucket,stops the users to hit
                    submit without selecting the file, reject the promise, potential refactor later to user chained promises,  and emit

                */
                if (!scope.isStorageUpdated) {
                    deferred.resolve();
                }
                else {

                    // scope.fileUploadError = "";
                    scope.getFileData().then(data => {
                        if (data == null)
                            deferred.reject();

                        let fileData = {
                            file: data,
                            fileName:  scope.file && scope.file.name,
                            fileGuid: scope.fileGuid || NewGuid(),
                            requestType: scope.fileType,
                            mimeType: scope.mimeType
                        };

                        if (fileData.file != null) {
                            scope.uploading = true;
                            scope.fileGuid = fileData.fileGuid;
                            scope.meevoFile['config'] = Model.Guard.isNothing(scope.meevoFile.config) ? scope.config : scope.meevoFile.config

                            this.dataService.addFile(scope.meevoFile.config.endPoint, fileData)
                                .then((result: any) => {
                                    if ((FileTypes[scope.fileType] != null ||
                                        FileTypes[scope.fileType] != undefined) &&
                                        typeof result.meevoFile !== 'undefined'

                                    ) {
                                        scope.meevoFile = result.meevoFile;
                                        scope.fileGuid = fileData.fileGuid;
                                        scope.mimeType = result.meevoFile.files[0].mimeType;
                                        scope.isStorageUpdated = true;
                                        deferred.resolve();
                                    }

                                    if (typeof result.error !== "undefined") {
                                        scope.fileUploadError = result.error;
                                    } else {
                                        scope.fileUploadError = "";
                                    }

                                }, (result: any) => { alert("Failed uploading" + result); })
                                .finally(() => {
                                    scope.uploading = false;
                                    scope.displayData = scope.croppedData
                                    scope.croppedData = null;
                                });
                        }
                        // else { scope.fileUploadError = "No File Selected";}
                    });
                };

                return deferred.promise;


            }

            scope.upload = scope.uploadFile;

            scope.getFileData = () => {
                const { file, croppedData } = scope;
                if (scope.showCropShape) {
                    return this.$q.resolve(croppedData);
                } else {
                    return this.Upload.dataUrl(file, true);
                }

            }

            scope.testCropShape = () => {
                if (scope.meevoFile != undefined &&
                    scope.meevoFile.config != undefined &&
                    scope.meevoFile.config.cropShape === "circle") {
                    return "preview-img-circle";
                } else {
                    return "preview-img-square";
                }
            }

            if (Model.Guard.isNothing(scope.meevoFile.config)) {
                scope.errors = {
                    invalidBig: 'ERROR_FILEUPLOAD_INVALIDSIZE_BIG',
                    invalidSmall: 'ERROR_FILEUPLOAD_INVALIDSIZE_SMALL',
                    invalidExecedesDimensions: 'ERROR_FILEUPLOAD_INVALIDSIZE_DIMENSIONS',
                }; 
                scope.fetchConfig();
            }

            scope.meevoFileImageUrl = Model.Guard.isSomething(scope.meevoFile.files) && Model.Guard.isSomething(scope.meevoFile.files[0]) ? scope.meevoFile.files[0].fileUrl : null
            scope.fileType = scope.fileType | scope.meevoFile.storageTypeEnum;
        }
       public loading: string;
        constructor(
            private $mdDialog: ng.material.IDialogService,
            private $q: angular.IQService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private $translate: angular.translate.ITranslateService,
            private Upload: any
        ) {
            this.loading = this.$translate.instant("MESSAGE_LOADING");
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($mdDialog: ng.material.IDialogService, $q: angular.IQService, dataService: Meevo.Components.BaseClasses.IDataService, $translate: angular.translate.ITranslateService, Upload: any) => {
                return new MeevoImageFileUpload($mdDialog, $q, dataService, $translate, Upload);
            };
            directive.$inject = ["$mdDialog", "$q", "meevo.components.common.DataService", "$translate", "Upload"];
            return directive;
        }
    }

    angular.module("meevo.components.imageFileUpload")
        .directive("meevoImageFileUpload", MeevoImageFileUpload.factory());
}